export const T = {
  blue: "#4e73df",
  green: "#1cc88a",
  teal: "#36b9cc",
  yellow: "#f6c23e",
  red: "#e74a3b",
  purple: "#6f42c1",
  orange: "#fd7e14",
  bg: "#f4f6fb",
  card: "#ffffff",
  border: "#eaeaea",
  text: "#212529",
  muted: "#6c757d",
  light: "#f1f3f5",
};

export const MEDAL_COLORS = ["#f6c23e", "#adb5bd", "#cd7f32"];

export const EMPTY_DASHBOARD_DATA = {
  companies: [],
  companyGroups: [],
  users: [],
  parties: [],
  modules: [],
  pages: [],
  roles: [],
  roleAccess: [],
  employees: [],
  generalMasters: [],
  settings: [],
  logs: [],
};
